import { EnumDynamicExportRunState } from '@Model';
import { type BadgeVariations } from '@synqo/frontend-component-library';

export const DynamicExportCategory = {
    Invoices: 'invoices',
    CashJournals: 'cash_journals',
    InvoiceSnapshots: 'invoice_snapshots',
} as const;

export const DynamicExportKey = {
    Accounting: 'accounting',
    Positions: 'positions',
    Overview: 'overview',
} as const;

export const getDynamicExportCategoryLabel = (value: string): string => {
    switch (value) {
        case DynamicExportCategory.Invoices:
            return 'Rechnungen';
        case DynamicExportCategory.CashJournals:
            return 'Kassenbücher';
        case DynamicExportCategory.InvoiceSnapshots:
            return 'Rechnungen (Portal)';
        default:
            return 'Unbekannt';
    }
};

export const getDynamicExportKeyLabel = (value: string): string => {
    switch (value) {
        case DynamicExportKey.Accounting:
            return 'FiBu';
        case DynamicExportKey.Positions:
            return 'Positionen';
        case DynamicExportKey.Overview:
            return 'Übersicht';
        default:
            return 'Unbekannt';
    }
};

/** What a run exports, as the one line that names it: "Rechnungen · FiBu". */
export const getDynamicExportTypeLabel = (category: string, key: string): string =>
    `${getDynamicExportCategoryLabel(category)} · ${getDynamicExportKeyLabel(key)}`;

/**
 * How a run's state reads and looks. Lives here rather than next to the table columns, so the
 * detail view and the list cannot end up calling the same state differently.
 */
export const getStateLabelAndVariant = (
    state: EnumDynamicExportRunState,
): { label: string; variant: Extract<BadgeVariations, 'success' | 'warning' | 'danger' | 'info' | 'default'> } => {
    switch (state) {
        case EnumDynamicExportRunState.Scheduled:
            return { label: 'Geplant', variant: 'default' };
        case EnumDynamicExportRunState.Running:
            return { label: 'In Bearbeitung', variant: 'info' };
        case EnumDynamicExportRunState.Finished:
            return { label: 'Abgeschlossen', variant: 'success' };
        case EnumDynamicExportRunState.Failed:
            return { label: 'Fehlgeschlagen', variant: 'danger' };
        default:
            return { label: 'Unbekannt', variant: 'default' };
    }
};
